import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

import { ConfigFiltro, ElencoFiltriCRUD, Filtro } from './filtri.type';
import * as _ from 'lodash';
import { FiltriParser } from './services/parser/filtri-parser';

@Injectable()
export class ElencoFiltriService implements ElencoFiltriCRUD {
  configFiltri: ConfigFiltro[] = [];
  listaConfigFiltriSub: BehaviorSubject<ConfigFiltro[]>;

  private _filtri: Filtro[] = [];
  listaFiltriSub: Subject<Filtro[]>

  parseFiltri: FiltriParser = new FiltriParser();

  constructor() {
    this.listaFiltriSub = new Subject();
    this.listaConfigFiltriSub = new BehaviorSubject([]);
  }

  set filtri(value){
    const filtriOrdered = _.orderBy(value, ['idConfig'], ['desc']);
    this._filtri=filtriOrdered;
  }

  get filtri(){
    return this._filtri;
  }

  /**
   * utilizzato da crud-serverside.ts
   * @returns 
   */
  getListaFiltriAsObservable(): Observable<Filtro[]> {
    return this.listaFiltriSub.asObservable();
  }

  /**
   * utilizzato da crud-serverside.ts
   * @param filtroInput 
   */
  aggiungiFiltro(filtroInput: Filtro) {
    // console.log("aggiungiFiltro", new Date(), filtroInput);
    this.filtri.push(filtroInput);
    this.aggiornaListaFiltri();
  }

  /**
   * utilizzato da crud-serverside.ts
   * @param filtriInput 
   * @param updateSubscribed 
   */
  setFiltri(filtriInput: Filtro[] = [], updateSubscribed: boolean = true) {
    // console.log("setFiltri", new Date(), filtriInput, updateSubscribed);
    this.filtri = filtriInput;
    this.aggiornaListaFiltri(updateSubscribed);
  }

  /**
   * Metodo privato che aggiorna il campo filtri senza emittare 
   * @param filtriInput 
   */
  private updateFiltri(filtriInput: Filtro[] = []) {
    this.filtri = filtriInput;
  }

  /**
   * 
   * @param filtriInput 
   */
  setPreviousFilters(filtriInput: Filtro[] = []) {
    // console.log("setPreviousFilters", filtriInput);
    this.filtri = filtriInput;
  }

  /**
   * utilizzato da crud-serverside.ts
   * @param filtriConfigInput 
   */
  setConfigFiltri(filtriConfigInput: ConfigFiltro[] = []) {
    // console.log("setConfigFiltri", filtriConfigInput);
    this.configFiltri = filtriConfigInput;
    this.listaConfigFiltriSub.next(this.configFiltri);
  }

  /**
   * utilizzato da crud-serverside.ts
   * @param indice 
   * @param filtro 
   */
  setFiltrobyIndice(indice: number, filtro: Filtro) {
    let filtroPresente = this.filtri[indice];
    if (filtroPresente !== null && filtroPresente !== undefined) {
      this.filtri[indice] = filtro;
    }
    this.aggiornaListaFiltri();
  }

  /**
   * usato da lista-filtri-compilabili
   * @param id 
   * @param value 
   */
  setValoreFiltrobyId(id: string, value: any) {
    let filtroPresente = this.filtri.find(el => el.idFiltro == id);
    if (filtroPresente !== null && filtroPresente !== undefined) {
      const config = this.configFiltri.find(el => el.id == filtroPresente.idConfig);
      filtroPresente.formValue = value;
      filtroPresente.valore = value;
      filtroPresente.isAttivo = true;
    }
    this.aggiornaListaFiltri();
  }

  /**
   * usato da lista-filtri-compilabili
   * @param id 
   * @param attivo 
   * @param valore 
   */
  cambiaStatoFiltrobyId(id: string, attivo: boolean = false, valore: any = undefined) {
    let filtroPresente = this.filtri.find(el => el.idFiltro == id);
    if (filtroPresente !== null && filtroPresente !== undefined) {
      if (valore !== undefined) {
        filtroPresente.valore = valore;
        filtroPresente.formValue = valore;
      }
      filtroPresente.isAttivo = attivo;
    }
    this.aggiornaListaFiltri();
  }

  aggiornaListaFiltri(updateSubscribed: boolean = true) {
    if (updateSubscribed) {
      this.listaFiltriSub.next(this.filtri);
    }
  }

  /**
   * Utilizzando le config precedentemente settate nel this
   */
  getUpdatedFiltersFromConfig() {
    const newFilters = this.generateFiltersFromConfig();
    const filtersUpdated = this.getPreviousFiltersUpdatedByConfig();
    const filtersToSet = _.union(newFilters, filtersUpdated);
    this.updateFiltri(filtersToSet);
    // console.log("getUpdatedFiltersFromConfig", new Date(), newFilters, filtersUpdated);
  }

  /**
   * Controlla i filtri precedentemente settati e per ogni filtro aggiorna la propria configurazione
   * @returns 
   */
  getPreviousFiltersUpdatedByConfig() {
    let filtri: Filtro[] = [];
    try {
      filtri = _.cloneDeep(this.filtri.map(el => {
        try {
          const configAggiornata = this.configFiltri.find(config => config.id == el.idConfig);
          if (configAggiornata) {
            el.visibile = configAggiornata.visible;
            el.configFiltro = configAggiornata
          }
        } catch (e) {
          console.log(e);
        }
        return el;
      }));
      return filtri;
      // this.aggiornaListaFiltri();
    } catch (e) {
      console.log(e);
      return this.filtri;
    }
  }

  /**
   * Genera i filtri, se non presenti, dalle config
   * @returns 
   */
  generateFiltersFromConfig(): Filtro[] {
    // console.log("generateFiltersFromConfig", new Date());
    let filtri: Filtro[] = [];
    for (let config of this.configFiltri) {
      const filtriPresenti: Filtro[] = this.filtri.filter(el => el.idConfig == config.id) //filtri presenti con stesso idConfig;
      if (config.controlType !== 'selezione-multipla') {
        for (let operatore of config.operatori) {
          const opPresente = filtriPresenti.find((el: Filtro) => el.operatoreId == operatore);
          if (!opPresente) {
            const nuovoFiltro = this.ottieniFiltroDaOpEConfig(config, operatore, null)
            filtri.push(nuovoFiltro);
            // this.aggiungiFiltro(nuovoFiltro);
          }
        }
      } else {//selezione multipla è un caso particolare perchè ogni valore dello stesso campo config genera un filtro
        for (let operatore of config.operatori) {
          for (let option of config.options) {
            const filtroPresente = filtriPresenti.find((el: Filtro) => el.operatoreId == operatore && el.valore == option.id);
            if (!filtroPresente) {
              const nuovoFiltro = this.ottieniFiltroDaOpEConfig(config, operatore, option.id);
              // this.aggiungiFiltro(nuovoFiltro);
              filtri.push(nuovoFiltro);
            }
          }
        }
      }
    }

    return filtri;
  }

  /**
   * 
   * @param config 
   * @param operatore 
   * @param valore 
   * @returns 
   */
  ottieniFiltroDaOpEConfig(config: ConfigFiltro, operatore: number, valore: any = null): Filtro {
    let filtro: Filtro =
    {
      idFiltro: newIdFn(),
      nomeCampo: config.nomeCampo,
      label: config.label,
      valore: valore,
      formValue: valore,
      operatoreId: operatore,
      labelOperatore: null,//this.getLabelOperatore(operatore, config.mapOperatore),
      isAttivo: false,
      deletable: false,
      isPredefinito: false,
      visibile: config.visible,
      idConfig: config.id,
      configFiltro: Object.assign({}, config)
    };

    if (config.controlType !== 'selezione-multipla' && config.default) {
      let defaultFiltro = config.default.find(el => el.operatoreId == operatore);
      if (defaultFiltro) {
        filtro.valore = defaultFiltro.valore;
        filtro.formValue = defaultFiltro.formValue ? defaultFiltro.formValue : defaultFiltro.valore;
        filtro.isAttivo = true;
      }
    }


    return filtro;
  }

  getNFiltriAttivi(): number {
    const currentFiltriList =this.filtri;
    let nAttivi: number = 0;
    if (currentFiltriList && currentFiltriList.length > 0) {
      nAttivi = currentFiltriList.filter(el => {
        return el.isAttivo && (el.visibile == undefined || el.visibile == true);
      }).length
    }

    return nAttivi;
  }

  /**
   * usato da crud-serverside.ts
   * Ritorna array di indici che rispecchiano la query
   * @param nomeCampo
   * @param valore
   */
  hasFiltro(nomeCampo, valore = undefined): number[] {
    let index = [];
    for (let i in this.filtri) {
      let filtro: Filtro = this.filtri[i];

      if (filtro.nomeCampo === nomeCampo || filtro.idFiltro === nomeCampo) {
        if (valore) {
          //se valore impostato devo verificare
          if (filtro.valore == valore) {
            index.push(i); //inserisco l'indice dell'elemento trovato
          }
        } else {
          index.push(i); //inserisco indice
        }
      }
    }
    return index;
  }

  /**
   * utilizzato da crud-serverside.ts
   * @param indice 
   */
  rimuoviFiltrobyIndice(indice: number) {
    this.filtri.splice(indice, 1);
    this.aggiornaListaFiltri();
  }

  /**
 * utilizzato da crud-serverside.ts
 * @param indice 
 * @returns 
 */
  getFiltro(indice): Filtro {
    return this.filtri[indice];
  }

  getListaFiltriSnapshot(){
    return this.filtri;
  }

  //METODI DEPRECATI

  /**
  * @deprecated
  * chiamato da setConfigFiltri
  */
  aggiornaListaConfigFiltri() {
    this.setFiltriFromConfig();
    this.aggiornaConfigObjInFiltri();
    // this.listaConfigFiltriSub.next(this.configFiltri);
  }

  /**
   * @deprecated
   */
  aggiornaConfigObjInFiltri() {
    try {
      this.filtri = _.cloneDeep(this.filtri.map(el => {
        try {
          const configAggiornata = this.configFiltri.find(config => config.id == el.idConfig);
          if (configAggiornata) {
            el.visibile = configAggiornata.visible;
            el.configFiltro = configAggiornata
          }
        } catch (e) {
          console.log(e);
        }
        return el;
      }));
      this.aggiornaListaFiltri();
    } catch (e) {
      console.log(e);
    }
  }

  /**
   * @deprecated
   */
  setFiltriFromConfig() {
    // console.log("setFiltriFromConfig", new Date());
    for (let config of this.configFiltri) {
      const filtriPresenti: Filtro[] = this.filtri.filter(el => el.idConfig == config.id) //filtri presenti con stesso idConfig;
      if (config.controlType !== 'selezione-multipla') {
        for (let operatore of config.operatori) {
          const opPresente = filtriPresenti.find((el: Filtro) => el.operatoreId == operatore);
          if (!opPresente) {
            const nuovoFiltro = this.ottieniFiltroDaOpEConfig(config, operatore, null)
            this.aggiungiFiltro(nuovoFiltro);
          }
        }
      } else {//selezione multipla è un caso particolare perchè ogni valore dello stesso campo config genera un filtro
        for (let operatore of config.operatori) {
          for (let option of config.options) {
            const filtroPresente = filtriPresenti.find((el: Filtro) => el.operatoreId == operatore && el.valore == option.id);
            if (!filtroPresente) {
              const nuovoFiltro = this.ottieniFiltroDaOpEConfig(config, operatore, option.id);
              this.aggiungiFiltro(nuovoFiltro);
            }
          }
        }
      }
    }
  }
}


const newIdFn = () => {
  return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(2, 10);//pericoloso(?)
}